// extracted by mini-css-extract-plugin
export default {"card":"C3-z","carouselContainer":"D3-z","carouselContent":"E3-z"};